import bacalar from './BACALAR-WHITE.png';
import cancun from './CANCUN-WHITE.png';
import chetumal from './CHETUMAL-WHITE.png';
import costa from './COSTA-MUJERES-WHITE.png';
import holbox from './HOLBOX-WHITE.png';
import islaC from './ISLA-COZUMEL-WHITE.png';
import islaM from './ISLA-MUJERES-WHITE.png';
import mahahual from './MAHAHUAL-WHITE.png';
import playa from './PLAYA-DEL-CARMEN-WHITE.png';
import puerto from './PUERTOMORELOS-WHITE.png';
import tulum from './TULUM-WHITE.png';
import maya from './maya.png';

const exports = {
  logos: [
    bacalar,
    cancun,
    chetumal,
    costa,
    holbox,
    islaC,
    islaM,
    mahahual,
    maya,
    playa,
    puerto,
    tulum,
  ],
};

export default exports;
